// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#cv {
    padding: 1rem 7.5%;
}
#cv > address {
    padding: 1rem 0;
}
#cv > address > div.name {
    font-size: 200%;
    font-variant-caps: small-caps;
}
#cv h2 {
    font-weight: normal;
}
#cv > section {
    display: table;
    width: 100%;
}
#cv > section > h2 {
    display: table-header-group;
    border-bottom: 1px solid #FFF;
}
#cv > section > h2 > span {
    display: table-row;
}
#cv > section > ol {
    display: table-row-group;
    padding: 0;
    list-style-type: none;
}
#cv > section > ol > li {
    display: table-row;
}
#cv > section > ol > li > * {
    display: table-cell;
    padding: 1rem 0.5rem;
    vertical-align: top;
}
#cv > section > ol > li > div:first-of-type {
    width: 45%;
}
#cv > section > ol > li > div:first-of-type:only-child {
    width: 100%;
}
#cv > section > ol > li > div:nth-of-type(2) {
    width: 55%;
}
#cv span.specialization,
#cv span.formerTitle,
#cv span.workAddress,
#cv span[itemProp="address"] {
    margin: 0;
    font-size: 75%;
}
`, "",{"version":3,"sources":["webpack://./src/cv/cv.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,WAAW;AACf;AACA;IACI,2BAA2B;IAC3B,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;;;;IAII,SAAS;IACT,cAAc;AAClB","sourcesContent":["#cv {\n    padding: 1rem 7.5%;\n}\n#cv > address {\n    padding: 1rem 0;\n}\n#cv > address > div.name {\n    font-size: 200%;\n    font-variant-caps: small-caps;\n}\n#cv h2 {\n    font-weight: normal;\n}\n#cv > section {\n    display: table;\n    width: 100%;\n}\n#cv > section > h2 {\n    display: table-header-group;\n    border-bottom: 1px solid #FFF;\n}\n#cv > section > h2 > span {\n    display: table-row;\n}\n#cv > section > ol {\n    display: table-row-group;\n    padding: 0;\n    list-style-type: none;\n}\n#cv > section > ol > li {\n    display: table-row;\n}\n#cv > section > ol > li > * {\n    display: table-cell;\n    padding: 1rem 0.5rem;\n    vertical-align: top;\n}\n#cv > section > ol > li > div:first-of-type {\n    width: 45%;\n}\n#cv > section > ol > li > div:first-of-type:only-child {\n    width: 100%;\n}\n#cv > section > ol > li > div:nth-of-type(2) {\n    width: 55%;\n}\n#cv span.specialization,\n#cv span.formerTitle,\n#cv span.workAddress,\n#cv span[itemProp=\"address\"] {\n    margin: 0;\n    font-size: 75%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
